export const saveToCollection =
  (collection) =>
    async ({ '.key': id, ...doc }) => {
      const docRef = collection().doc(id)
      await docRef.set(doc)
      return docRef
    }

export const deleteFromCollection =
  (collection) =>
    ({ '.key': id }) =>
      collection().doc(id).delete()
